import { ContentTypeView, Inserter, PartOlddesign, TinymcePortal } from "nystem-components";
import "./index.css";

const Index = () => (
  <>
    <TinymcePortal />
    <Inserter match="/olddesign"><PartOlddesign /></Inserter>
    <Inserter match="/*" exclude="/olddesign"><ContentTypeView contentType="travelsSite" format="view" /></Inserter>
  </>
);

export default Index;
